import { Action } from '@ngrx/store';


export enum AdminUserActionType {
  GETAdmin_INFO = '[Admin] Login',
  INFOAdmin_SUCCESS = '[Admin] Info Success'
}

export class AdminUserInfo implements Action {
  readonly type = AdminUserActionType.GETAdmin_INFO;
  constructor(public payload?: any) {}
}

export class AdminUserInfoSuccess implements Action {
  readonly type: string = AdminUserActionType.INFOAdmin_SUCCESS;
  constructor(public payload: any) { }
}

export type All =
| AdminUserInfo
| AdminUserInfoSuccess;